module.exports = __webpack_public_path__ + "static/media/logo.47c4581a.svg";